import UgcRotateImageControl from "./RotateImageControl";

export default UgcRotateImageControl;
